import React, { useState, useEffect } from "react";
import "./global.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CatalogProvider from "./context/CatalogContext";
import Header from "./components/Header";
import MenuBar from "./components/MenuBar";
import Home from "./pages/Home";
import AboutUs from "./pages/About_us";
import Contact from "./pages/Contact";
import ItemDetail from "./pages/ItemDetail";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Products from "./pages/Products";
// import Services from "./pages/Services";
import PriceList from "./pages/PriceList";
import { fetchContactData } from "./utils/api";
import { ContactData } from "../src/data-types/api-client/api-contacts";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiesComponent from "./components/CookiesComponent";
import Loading from "./components/Loading";

const App: React.FC = () => {
  const [contact, setContact] = useState<ContactData | undefined>(undefined); // Initialize as null
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title =
      "Požičovňa náradia Tvrdošín (Trstená, Nižná a okolie) - rentkos.sk";
  }, []);

  useEffect(() => {
    const getContact = async () => {
      try {
        setLoading(true);
        const data = await fetchContactData(); // Fetch contact data once
        setContact(data); // Set contact data
      } catch (err: any) {
        setError(err.message); // Handle error
      } finally {
        setLoading(false); // End loading state
      }
    };

    getContact();
  }, []);

  if (error) {
    return <div>Error: {error}</div>; // Error state
  }

  const menuItems = [
    { label: "Domov", path: "/" },
    { label: "O nás", path: "/o-rentkos-spolocnosti" },
    { label: "Prenájom zariadení", path: "/prenajom-zariadeni" },
    // { label: "Služby", path: "/sluzby" },
    { label: "Cenník", path: "/cennik" },
    { label: "Kontakt", path: "/kontakt" },
  ];

  return (
    <>
      {loading && <Loading />}
      <CatalogProvider>
        <Router>
          <div className="m-0 p-0 flex flex-col min-h-screen">
            <ScrollToTop />
            <Header contact={contact} />
            <MenuBar items={menuItems} contact={contact} />
            <div className="">
              <Routes>
                <Route path="/" element={<Home contact={contact} />} />
                <Route
                  path="/o-rentkos-spolocnosti"
                  element={<AboutUs contact={contact} />}
                />
                <Route path="/prenajom-zariadeni" element={<Products />} />
                {/* <Route path="/sluzby" element={<Services />} /> */}
                <Route
                  path="/cennik"
                  element={<PriceList contact={contact} />}
                />
                <Route
                  path="/prenajom-zariadeni/:category/:title/:productId"
                  element={<ItemDetail />}
                />
                <Route
                  path="/kontakt"
                  element={<Contact contact={contact} />}
                />
                <Route
                  path="/sukromie"
                  element={<PrivacyPolicyPage contact={contact} />}
                />
              </Routes>
            </div>
            <Footer contact={contact} />
            <CookiesComponent />
          </div>
        </Router>
      </CatalogProvider>
    </>
  );
};

export default App;
